import { useState, useStore } from 'vuex-composition-helpers';
import { ref, unref } from 'vue';

import { IPopupWrapper } from '@ve/components/popupWrapper/common/types';
import registerModule from '@ve/services/registerModule';
import RailwayToursListStore from './store/RailwayToursListStore';

const storeModuleName = 'railwayToursListStore';

export default () => {
    const store = useStore();

    registerModule
        .register(store, RailwayToursListStore, storeModuleName);

    const { railwayTourItems } = useState(storeModuleName, ['railwayTourItems']);

    const railwayToursListPopup = ref<IPopupWrapper | null>(null);

    const open = () => {
        unref(railwayToursListPopup)?.open();
    };

    const close = () => {
        unref(railwayToursListPopup)?.close();
    };

    return {
        railwayTourItems,
        railwayToursListPopup,
        open,
        close,
    };
};